import Image from 'next/image';

import DisplayCard from './DisplayCard';

interface PointsRankingCardProps {
  totalPoints: number;
  ranking: number | null;
  width?: number;
}

const PointsRankingCard: React.FC<PointsRankingCardProps> = ({ totalPoints, ranking, width }: PointsRankingCardProps) => {
  return (
    <div className='flex flex-1 xl:flex-none shrink-0'>
      <div className='flex-1 z-10'>
        <DisplayCard
          title='Quanta'
          value={totalPoints}
          width={width}
          icon={<Image src='/assets/quanta/quanta-points.png' alt='Quanta' width={24} height={24} />}
        />
      </div>
      <div className='flex-1 -ml-10'>
        <DisplayCard title='Ranking' value={ranking} isBorder={true} width={width} />
      </div>
    </div>
  );
};

export default PointsRankingCard;
